export function classNames(...classes: string[]) {
  // supports the normal sytanx classNames('classA', true && 'classB')
  // but also the Astro class:list style classNames({'classA': truthyVar, 'classB': falsyVar})
  return classes
    .filter(Boolean)
    .map((className) => {
      if (typeof className === "object") {
        return Object.entries(className)
          .filter(([, value]) => value)
          .map(([key]) => key)
          .join(" ");
      }
      return className;
    })
    .join(" ");
}
